import axios from "axios";
import store from "../store";
import { apiBasePath } from "../config";
import { actionTypes } from "../store-types";

axios.defaults.baseURL = apiBasePath;
// احراز هویت اکنون با کوکی HttpOnly است؛ همه‌ی درخواست‌ها باید کوکی را همراه ببرند.
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
    config.withCredentials = true;
    return config;
});

// --- Response: مدیریت انقضای نشست ---
let handlingUnauthorized = false;
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error && error.response && error.response.status;
        const url = (error && error.config && error.config.url) || "";
        const isAuthCall = /account\/(login|register|forgotpassword|confirm|resendCode|session|IsAuthenticated)/i.test(url);
        // ثبت خطا نباید باعث logout/redirect شود
        const isLogCall = /(^|\/)LogEvent(\/|$)/i.test(url);

        if (status === 401 && !isAuthCall && !isLogCall && !handlingUnauthorized) {
            handlingUnauthorized = true;
            try {
                store.dispatch(actionTypes.CLEAR_LOGIN);
            } catch (e) {
                /* noop */
            }
            const path = typeof location !== "undefined" ? location.pathname : "";
            if (!/^\/account\//.test(path)) {
                location.assign("/account/login");
            }
        }
        return Promise.reject(error);
    }
);

export default {
    basePath: apiBasePath,
};
